import ModalPaymentBanks from './ModalPaymentBanks'

export default ModalPaymentBanks
